import { API } from 'aws-amplify';

export default {
  state: {
  },
  tableName(name) {
    switch (name) {
      case 'marquee': return process.env.VUE_APP_MARQUEES_TABLE_NAME;
      case 'product': return process.env.VUE_APP_PRODUCTS_TABLE_NAME;
      case 'category': return process.env.VUE_APP_CATEGORY_TABLE_NAME;
      case 'comment': return process.env.VUE_APP_COMMENT_TABLE_NAME;
      case 'info': return process.env.VUE_APP_INFO_TABLE_NAME;
      case 'operation': return process.env.VUE_APP_OPERATION_TABLE_NAME;
      case 'install': return process.env.VUE_APP_INSTALL_TABLE_NAME;
      case 'smb': return process.env.VUE_APP_SMB_TABLE_NAME;
      case 'user': return process.env.VUE_APP_USER_TABLE_NAME;
      case 'custom': return process.env.VUE_APP_CUSTOM_TABLE_NAME;
      case 'permission': return process.env.VUE_APP_PERMISSION_TABLE_NAME;
      case 'recommendItem': return process.env.VUE_APP_RECOMMEND_ITEM_TABLE_NAME;
      case 'recommendLvq': return process.env.VUE_APP_RECOMMEND_LVQ_TABLE_NAME;
      case 'recommendRating': return process.env.VUE_APP_RECOMMEND_RATING_TABLE_NAME;
      case 'recommendInstall': return process.env.VUE_APP_RECOMMEND_INSTALL_TABLE_NAME;
      case 'recommendOperation': return process.env.VUE_APP_RECOMMEND_OPERATION_TABLE_NAME;
      case 'support': return process.env.VUE_APP_SUPPORT_TABLE_NAME;
      case 'chatService': return process.env.VUE_APP_CHATSERVICE_TABLE_NAME;
      default: return '';
    }
  },
  scan(name, item = {}, field = []) {
    return new Promise((resolve, reject) => {
      API.post('API', '/awsDB', {
        body: {
          operation: 'scan', tableName: this.tableName(name), item, field,
        },
      })
        .then((response) => {
          resolve(response.data);
        }).catch((error) => {
          reject(error);
        });
    });
  },
  read(name, primaryKey, item, field = []) {
    return new Promise((resolve, reject) => {
      API.post('API', '/awsDB', {
        body: {
          operation: 'read', tableName: this.tableName(name), primaryKey, value: item, field,
        },
      })
        .then((response) => {
          resolve(response.data);
        }).catch((error) => {
          reject(error);
        });
    });
  },
  create(name, item) {
    return new Promise((resolve, reject) => {
      API.post('API', '/awsDB', { body: { operation: 'create', tableName: this.tableName(name), item } }).then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  update(name, primaryKey, item) {
    return new Promise((resolve, reject) => {
      API.post('API', '/awsDB', {
        body: {
          operation: 'update', tableName: this.tableName(name), primaryKey, item,
        },
      }).then((response) => {
        resolve(response);
      }).catch((error) => {
        reject(error);
      });
    });
  },
  // delete(items) {
  //     return new Promise(async(resolve, reject) => {
  //             API.post('API', '/awsDB', { body: { operation: 'delete', tableName: process.env.USERS_TABLE_NAME, primaryKey: 'email', value: items.email } }).then(response => {
  //                 resolve(response)
  //             }).catch(error => {
  //                 reject(error)
  //             })
  //             resolve(response)
  //     })
  // },
  query(name, key, item) {
    return new Promise((resolve, reject) => {
      API.post('API', '/awsDB', {
        body: {
          operation: 'query', tableName: this.tableName(name), key, item,
        },
      })
        .then((response) => {
          resolve(response);
        }).catch((error) => {
          reject(error);
        });
    });
  },
};
